import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import { gostSesija } from '../auth/gost'
import { useGostSesija, useSession } from '../auth/useSession'
import {
  Ekran,
  Eyebrow,
  GumbLink,
  IzbornikJezika,
  Naslov,
  Podnaslov,
  Uputa,
} from '../components/noir'
import { Znak } from '../components/Znak'
import { KORIJEN_GOSTA, pocetnaZaUlogu } from './rute'

/**
 * Korijen aplikacije (`/`) — jedina adresa koja ne pripada nijednoj ulozi.
 *
 * **Zašto postoji** (Z15 dopuna): manifest je do sada imao `start_url: "/g"`, pa
 * je SVAKA instalacija bila gostova. Bellboy koji aplikaciju stavi na početni
 * zaslon — a njemu je push u džepu najpotrebniji — dobivao je ikonu koja ga
 * otvara na ekranu za goste. Instalacija je jedna po uređaju i ne zna tko će je
 * pokrenuti, pa `start_url` mora biti adresa koja to pita, a ne adresa jedne
 * uloge.
 *
 * **Odluka je usmjeravanje, ne dokazivanje.** Živa sesija osoblja je ovdje već
 * podignuta (`App` na neguestovoj adresi čeka `/auth/refresh`), pa se čita
 * izravno. Gostova se NE podiže: dovoljno je da u pohrani stoji njegov refresh
 * token — dokaz da sesija još vrijedi ostavlja se okviru gosta, koji ga ionako
 * traži pri svakom ulasku. Tako korijen ne uvodi treću ruku koja rotira tuđi
 * token (isti razlog zbog kojeg se sesija osoblja ne dira na `/g`, vidi
 * `app/rute.ts`), a mrtav token nije slijepa ulica nego put na gostov ulaz.
 *
 * **Osoblje se gleda prije gosta**, kao i u povratku s nepoznate adrese
 * (`App.tsx`): konzola je ta koja stoji otvorena na računalu s pulta, pa
 * gostova sesija na istom uređaju ne smije preoteti adresu.
 */
export function Korijen() {
  const { t } = useTranslation()
  const sesija = useSession()
  const gost = useGostSesija()

  if (sesija.accessToken) return <Navigate to={pocetnaZaUlogu(sesija.uloga)} replace />

  if (gost.accessToken || gostSesija.imaZapamcenuSesiju()) {
    return <Navigate to={KORIJEN_GOSTA} replace />
  }

  return (
    <Ekran>
      <div className="mb-4 flex justify-end">
        <IzbornikJezika />
      </div>

      <div className="mb-4 flex justify-center">
        <Znak velicina={44} />
      </div>

      <Eyebrow>{t('app.name')}</Eyebrow>
      <Naslov>{t('app.korijen.naslov')}</Naslov>
      <Podnaslov>{t('app.korijen.uvod')}</Podnaslov>

      {/*
        Gost je gore jer ih je najviše, osoblje ispod jer ono zna gdje ide —
        recepcioner i vozač ovaj ekran vide jednom, prije prve prijave.
      */}
      <div className="flex flex-col gap-3">
        <GumbLink na={KORIJEN_GOSTA}>{t('app.korijen.gost')}</GumbLink>
        <GumbLink na="/login" izgled="obrub">
          {t('app.korijen.osoblje')}
        </GumbLink>
      </div>

      <Uputa>{t('app.korijen.uputa')}</Uputa>
    </Ekran>
  )
}
